<div class="workflow-save-row">
  <div class="detailed-action">
    <wm-common-text
      [data]="{text: row.detailedAction}"
    ></wm-common-text>
  </div>
  <div class="resume-btn">
    <wm-common-button
      [data]="{text: 'RESUME', variant: 'basic'}"
      (click)="emit('resume')"
    ></wm-common-button>
    <wm-common-button
      [data]="{text: 'DELETE'}"
      (click)="emit('delete')"
    ></wm-common-button>
  </div>
</div>
